<template>
  <div>
    <a
      v-if="companyId && !isExporting"
      href="#"
      title=""
      class="action-bar__link"
      @click.prevent="exportProjects"
    >{{ $t(`${namespace}.export`) }}</a>
    <span v-if="isExporting" class="accent--text">{{ $t('Common.loading') }}</span>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { exportAsync } from 'utils/exportAsync'

export default {
  name: 'ExportProjectAction',
  props: {
    search: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapState({
      company: state => state.company.selectedCompany
    }),

    companyId () {
      if (this.$route.name === 'CompanyDetail') {
        return this.$route.params.id
      }

      return this.company ? this.company.id : null
    }
  },
  data () {
    return {
      namespace: 'Views.ProjectsPage',
      isExporting: false,
      downState: {
        downloadCsvAutoRequest: undefined,
        downloadCsvPercentage: 0
      }
    }
  },
  methods: {
    ...mapActions({
      successAlert: 'snackbarAlert/success',
      errorAlert: 'snackbarAlert/error',
      showAlert: 'snackbar/show'
    }),

    onExportAsyncSuccess () {
      this.successAlert(this.$t(`${this.namespace}.successExport`))
      this.isExporting = false
    },

    onExportAsyncError () {
      this.showAlert({
        type: 'error',
        message: this.$t('Common.errorExport')
      })
      this.isExporting = false
    },

    async exportProjects () {
      this.isExporting = true

      try {
        exportAsync(
          { companyId: this.companyId, search: this.search, type: 'configProject' },
          '99Empresas_projetos.csv',
          this.onExportAsyncSuccess,
          this.onExportAsyncError,
          this.downState
        )
      } catch (err) {
        this.onExportAsyncError()
      }
    }
  },
  destroyed () {
    // clearInterval(this.downState.downloadCsvAutoRequest)
  }
}
</script>
